import styled from "styled-components";

import { ICONS } from "../../BaseComponents/Image";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { MEDIA_QUERIES } from "context/media/MediaConstant";

export const StyledDesktopRightMenu = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  cursor: pointer;
  margin-right: 25px;

  color: ${DIGIPOSTHEME.colors.white};

  z-index: 2;

  outline: 0;

  & > :nth-child(2) {
    cursor: default;
  }

  & > :nth-child(1) {
    cursor: pointer;
  }

  & > :nth-child(1):not(:focus) .dropdown {
    display: none;

    opacity: 0;
    transition: all 0.3s ease-out;
  }

  & > :nth-child(1):focus .dropdown {
    max-height: 90vh;

    display: block;

    opacity: 1;
  }

  & > :nth-child(1):focus + :nth-child(2) {
    box-shadow: 0 1px 7px 6px ${DIGIPOSTHEME.colors.avatarFocusShadow};
  }

  @media ${MEDIA_QUERIES.MOBILE} {
    margin-right: 0;
  }
`;

export const StyledDropdown = styled.div`
  width: 240px;

  position: absolute;

  top: 65px;
  right: 34px;

  background-color: ${DIGIPOSTHEME.colors.white};

  color: black;
  font-family: "Campton";

  opacity: 1;
  z-index: 2;

  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  box-shadow: 0px 0px 14px 0 ${DIGIPOSTHEME.colors.avatarMenuShadow};

  & > :nth-last-child(2) {
    border-bottom: solid 1px ${DIGIPOSTHEME.colors.avatarMenuBottomShadow};
  }

  @media ${MEDIA_QUERIES.MOBILE} {
    top: 48px;
    right: 9px;
  }
`;

export const StyledSubMenu = styled.div`
  display: flex;
  align-items: center;

  padding: 10px 0px 5px 16px;

  color: ${DIGIPOSTHEME.colors.secondaryBlack};
  font-size: 13px;
  font-weight: 500;

  cursor: pointer;

  &:hover {
    background-color: ${DIGIPOSTHEME.colors.secondaryGrayTertiary};
  }

  @media ${MEDIA_QUERIES.MOBILE} {
    padding: 5px 0px 5px 16px;

    font-size: 12px;
  }
`;

export const StyledWelcomeField = styled.div`
  padding: 10px 0px 10px 16px;

  border-bottom: solid 1px ${DIGIPOSTHEME.colors.avatarMenuBottomShadow};
`;

export const StyledImageField = styled.div`
  width: 53px;
  height: 46px;

  order: 1;

  display: flex;
  justify-content: center;
  align-items: center;

  margin: 10px 0 10px 10px;
  padding: 9px;

  background-color: white;

  font-size: 15px;
  color: ${DIGIPOSTHEME.colors.red};
  font-weight: 700;
  font-family: Campton;

  border-radius: 50%;

  @media ${MEDIA_QUERIES.MOBILE} {
    margin: 0;
    padding: 6px;
  }
`;

export const StyledRefreshMerchantWrapper = styled.div<{
  hasChangeMerchant?: boolean;
}>`
  display: flex;
  align-items: center;

  & > :nth-child(2) {
    background: url(${ICONS.REFRESH});
  }

  &:hover {
    & > :nth-child(2) {
      background: url(${ICONS.REPEAT});
    }

    ${({ hasChangeMerchant }) =>
      hasChangeMerchant &&
      `cursor: pointer;
    
      & > :first-child > :last-child {
        text-decoration: underline;
        font-weight: bold;
      }`};
  }
`;

export const StyledImageWrapper = styled.div<{ hasChangeMerchant?: boolean }>`
  width: 32px;
  height: 32px;

  ${({ hasChangeMerchant }) => !hasChangeMerchant && "display: none;"};
`;

export const StyledContentContainer = styled.div`
  display: flex;
`;

export const StyledText = styled.div`
  width: auto;

  margin: 0px;

  font-family: Campton;
  font-size: 10px;
  text-align: left;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.1px;
  color: ${DIGIPOSTHEME.colors.secondaryGrayPrimary};
`;
